import React, { ChangeEventHandler, FocusEventHandler, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";

interface PlaceURLLinkProps {
  id?: string;
  index: number;
  name?: string;
  title?: string;
  value?: string;
  onRemove?: () => void;
  notesclass?: string;
  disabled?: boolean;
}

export const PlaceURLLink = ({ id, index, name, title, value = "", onRemove, notesclass = "", disabled }: PlaceURLLinkProps) => {
  const removeItem = () => {
    onRemove && onRemove();
  };

  return (
    <>
      <div className="relative w-full min-w-[200px]">
        {title && (
          <div className="flex items-center">
            <span>{index && <span className="content_count">{index}</span>}</span>
            {title && <span className="content_title">{title}</span>}
          </div>
        )}
        <div className={`flex items-center gap-[15px] ${title ? "mt-[15px]" : "mt-[0px]"}`}>
          <Link to={value} target="_blank" rel="noopener noreferrer" className="font-bold ">
            {value}
          </Link>
          {!disabled && value.trim() && (
            <div className="content-center w-4 h-4 align-middle shadow-md top-1 rounded-3xl bg-slate-600 max-w-[486px] mr-[5px] mt-[5px]">
              <button
                id="removeItem"
                className="top-0 left-0 right-0 content-center w-4 h-4 text-white "
                onClick={e => {
                  e.stopPropagation();
                  removeItem();
                }}
              >
                ×
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
